import { render, staticRenderFns } from "./blockLeftCenter.vue?vue&type=template&id=ee522146&scoped=true&"
import script from "./blockLeftCenter.vue?vue&type=script&lang=js&"
export * from "./blockLeftCenter.vue?vue&type=script&lang=js&"
import style0 from "./blockLeftCenter.vue?vue&type=style&index=0&id=ee522146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee522146",
  null
  
)

export default component.exports